export const taxIdNumberLabels: { [key: string]: string } = {
  AUD: 'ABN (Australian Business Number)',
  NZD: 'GST Registration Number',
  USD: 'EIN (Employer Identification Number)',
  GBP: 'VAT Reference Number',
  EUR: 'VAT Reference Number',
  ZAR: 'VAT Reference Number',
}
